import { render, staticRenderFns } from "./FooterLogos.vue?vue&type=template&id=afc7c24c"
import script from "./FooterLogos.vue?vue&type=script&lang=js"
export * from "./FooterLogos.vue?vue&type=script&lang=js"
import style0 from "./FooterLogos.vue?vue&type=style&index=0&id=afc7c24c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports